import { useReactiveVar } from '@apollo/client'
import { labelCodeIdVar } from 'modulesCommon/store'
import { Label } from '../__gql-types'

export const useCurrentZone = (zonesList: Label[]) => {
  // TODO: get rid of reactive vars
  const currentZoneId = useReactiveVar(labelCodeIdVar)

  const currentZone = zonesList.find((zone) => zone.id === currentZoneId)

  return {
    currentZone
  }
}
